import React, { useContext } from 'react';
import { AuthContext } from '../../navigation/AuthProvider';
import AsyncLocalStorage from '../../utils/AsyncLocalStorage';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import { LoginAccountFind } from './LoginAccountFind';
import { LoginFindSuccess } from './LoginFindSuccess';

export const LoginForgetMain = (oProps: any) => {
  const navigate = useNavigate();
  const [findIdSuccess, setFindIdSuccess] = React.useState<boolean>(false);
  const [findPasswordSuccess, setFindPasswordSuccess] = React.useState<boolean>(false);
  const [findId, setFindId] = React.useState<string[]>([]);
  const [authenticationKey, setAuthenticationKey] = React.useState<number>(0);
  const [storeId, setStoreId] = React.useState<number>(0);
  const [title, setTitle] = React.useState<string>('아이디 / 비밀번호 찾기');

  const moveLoginPage = () => {
    navigate('/');
  };
  const moveFindPasswordPage = () => {
    setFindIdSuccess(false);
    setFindPasswordSuccess(false);
    navigate('/loginPasswordForget');
  };

  return (
    <Style>
      <div className="wrap">
        <div className="container">
          <div className="content">
            <button onClick={moveLoginPage} className="behindLogo">
              <img
                src={`${process.env.PUBLIC_URL}/img/title.png`}
                alt="logo"
                width="100%"
                style={{
                  maxWidth: '7.5rem',
                }}
              />
            </button>
            <h1 className="title">{title}</h1>
            {!findIdSuccess && !findPasswordSuccess ? (
              <LoginAccountFind
                setFindIdSuccess={setFindIdSuccess}
                setFindPasswordSuccess={setFindPasswordSuccess}
                setTitle={setTitle}
                typeForgot={oProps.typeForgot}
                moveLoginPage={moveLoginPage}
                setFindId={setFindId}
                setAuthenticationKey={setAuthenticationKey}
                authenticationKey={authenticationKey}
                setStoreId={setStoreId}
              />
            ) : (
              <LoginFindSuccess
                findIdSuccess={findIdSuccess}
                findPasswordSuccess={findPasswordSuccess}
                findId={findId}
                typeForgot={oProps.typeForgot}
                moveLoginPage={moveLoginPage}
                moveFindPasswordPage={moveFindPasswordPage}
                storeId={storeId}
                authenticationKey={authenticationKey}
              />
            )}
          </div>
          <div className="footer">
            <p>Copyright 2023. Invisible Ideas. All rights reserved</p>
          </div>
        </div>
      </div>
    </Style>
  );
};

export const Style = styled.div`
  ul,
  li {
    list-style: none;
  }
  .wrap {
    width: 100%;
    height: 100vh;
    background: #f8fafc;
  }
  .container {
    width: 100%;
    max-width: 30rem;
    margin: 0 auto;
    height: 100vh;
    padding: 3rem !important;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-between;
    border-radius: 0.5rem;
  }
  .content {
    width: 100%;

    .behindLogo {
      border: none;
      outline: none;
      background: none;
    }
  }
  h1 {
    font-size: 1.25rem;
    font-weight: 600;
    color: #4f5459;
  }
  button,
  label,
  label > input {
    cursor: pointer;
  }

  .title {
    margin-top: 3.5rem;
    margin-bottom: 2rem;
  }

  /* 로그인페이지 이동*/
  .backPageButton {
    width: 100%;
    border: none;
    outline: none;
    background: #fff;

    p {
      font-size: 0.875rem;
      font-weight: 400;
      color: #3538cd;
      text-decoration: underline;
      text-underline-offset: 0.3125rem;
    }
  }

  /* 고객센터 */
  .serviceCenter p {
    font-size: 1rem;
    font-weight: 400;
    color: #72727e;

    span {
      margin-right: 0.25rem;
      font-weight: 600;
      color: #444ce7;
    }
  }

  /* footer */
  .footer {
    p {
      margin: 0.25rem 0 0 0;
      font-size: 1rem;
      font-weight: 400;
      color: #72727e;
    }
  }

  @media (max-width: 800px) {
    .wrap {
      max-height: calc(var(--vh, 1vh) * 100);
      background: #fff;
    }
    .container {
      width: 100%;
      max-width: 100%;
      padding: 20px !important;
    }
    .title {
      margin-top: 32px;
      margin-bottom: 20px;
    }
    .loginFind {
      button {
        margin-left: 8px;

        p {
          font-size: 12px;
        }
      }
    }
    .footer {
      p {
        font-size: 12px;
      }
    }
  }
`;
